import type { ApiResult } from '../api'

export type BoxesData = NonNullable<ApiResult<'get', '/api/v3/boxes'>>

/**
 * Box resolution from a parcel's `boxId` (`custom-<id>` / `system-<id>`).
 * Only custom boxes have a weight; only system boxes have a carrier.
 */

export function getBox(boxes: BoxesData | undefined, boxId?: string | null) {
  if (boxId?.startsWith('custom-')) {
    return boxes?.custom.find((box) => `custom-${box.id}` === boxId) || null
  }
  if (boxId?.startsWith('system-')) {
    return boxes?.system?.find((box) => `system-${box.id}` === boxId) || null
  }
  return null
}

export function getBoxName(boxes: BoxesData | undefined, boxId?: string | null) {
  return getBox(boxes, boxId)?.name || null
}

export function getBoxCarrier(boxes: BoxesData | undefined, boxId?: string | null) {
  const box = getBox(boxes, boxId)
  return box && 'carrier' in box ? box.carrier : null
}

/**
 * Empty custom-box weight (oz), or `null` when auto-add is off — no box, a
 * system box, or a custom box with no positive weight. Mirrors the server's
 * `core/box/get-box-weight`: `null` means "the entered weight already includes
 * the box."
 */
export function getBoxWeight(boxes: BoxesData | undefined, boxId?: string | null): number | null {
  const box = getBox(boxes, boxId)
  if (box && 'weight' in box && box.weight != null && box.weight > 0) return box.weight
  return null
}
